module.exports = __webpack_public_path__ + "static/media/chat.381bd67c.svg";